module.exports = __webpack_public_path__ + "img/fb@2x.fc5c0d2a.webp";